import React from 'react';

import Button, { ButtonColor } from 'components/ButtonDeprecated';
import Glyph from 'components/Glyph';
import Row from 'components/Row';
// @ts-ignore
import Text from 'components/Text';

import './styles/UploadTextAndButton.scss';

type Props = {
  size: 'large' | 'small';
  // `pick` is the function that opens the file picker
  // generally, `pick` should be passed in from the `Picker` component
  pick: () => void;
  onClick?: () => void;
  error?: string;
  onErrorView?: () => void;
};

export default class UploadTextAndButton extends React.Component<Props> {
  componentDidMount() {
    if (this.props.error && this.props.onErrorView) {
      this.props.onErrorView();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.error !== this.props.error && this.props.error && this.props.onErrorView) {
      this.props.onErrorView();
    }
  }

  render() {
    return (
      <div
        onClick={() => {
          this.props.pick();
          if (this.props.onClick) this.props.onClick();
        }}
        style={{ cursor: 'pointer' }}>
        <Row size="small">
          <Glyph color="graphite" size="xxxlarge" name="drag-and-drop" />
        </Row>
        {!!this.props.error && (
          <Row size="xsmall">
            <Text color="apple" size={this.props.size}>
              {this.props.error}
            </Text>
          </Row>
        )}
        <Text color="graphite" size={this.props.size}>
          Drag and drop a CSV file or{' '}
          <Button level="text" color={ButtonColor.mascot} className="UploadTextAndButton-button">
            <Text size={this.props.size}>click here to upload it</Text>
          </Button>
        </Text>
      </div>
    );
  }
}
